import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-Events',
    templateUrl: './Events.component.html',
    styleUrls: ['./Events.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EventsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
